import type { SVGProps } from 'react'
const SvgSyPhoneMobile = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={10} height={17} x={7} y={3} fillOpacity={0.24} rx={2} />
		<circle cx={12} cy={18} r={1} />
		<path d="M9 4.13A.13.13 0 0 1 9.13 4h5.74a.13.13 0 0 1 .13.13c0 .48-.39.87-.87.87H9.87A.87.87 0 0 1 9 4.13" />
	</svg>
)
export default SvgSyPhoneMobile
